import cn from 'classnames';
import React from 'react';

import { BROWSE_ROW_TYPE } from 'app/constants/BrowseConstants';
import { rowConfigsShape } from 'app/shapes/browse';

import SearchBibsRow from './SearchBibsRow';
import LinkRow from './LinkRow';
import ListsRow from './ListsRow';
import NavRow from './NavRow';
import ListCardsRow from './ListCardsRow';
import ListBibsRow from './ListBibsRow';

import './Rows.scss';

// TODO: remove type LIST once LIST_HERO is implemented
const Rows = ({ rowConfigs }) => {
  const renderRow = rowConfig => {
    const { config, type } = rowConfig;

    switch (type) {
      case BROWSE_ROW_TYPE.BIB: {
        return <SearchBibsRow config={config} />;
      }
      case BROWSE_ROW_TYPE.LINK: {
        return <LinkRow config={config} />;
      }
      case BROWSE_ROW_TYPE.LIST: {
        return <ListsRow config={config} />;
      }
      case BROWSE_ROW_TYPE.LIST_BIB: {
        return <ListBibsRow config={config} />;
      }
      case BROWSE_ROW_TYPE.LIST_CARD: {
        return <ListCardsRow config={config} />;
      }
      case BROWSE_ROW_TYPE.LIST_HERO: {
        return <ListsRow config={config} />;
      }
      case BROWSE_ROW_TYPE.NAV: {
        return <NavRow config={config} />;
      }
      default:
        // eslint-disable-next-line no-console
        console.warn(`Unknown row type: ${type}`);
        return null;
    }
  };

  return (
    <div className="cp-browse-rows">
      {rowConfigs.map(rowConfig => {
        const { hasAlternativeStyle, rowConfigId, type } = rowConfig;

        const isNav = type === BROWSE_ROW_TYPE.NAV;

        return (
          <section
            className={cn('browse-rows__row', {
              'browse-rows__row--alt': hasAlternativeStyle,
              'browse-rows__row--nav': isNav
            })}
            key={rowConfigId}
          >
            <div className="container">
              <div className="row">
                <div className="col-md-12">{renderRow(rowConfig)}</div>
              </div>
            </div>
          </section>
        );
      })}
    </div>
  );
};

Rows.propTypes = {
  rowConfigs: rowConfigsShape.isRequired
};

export default Rows;
